export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13812.97960500.jpg";